import { useState, useEffect } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import Audi from "images/audi.png";
import BMW from "images/BMW.png";
import Ford from "images/Ford.png";
import Peugeot from "images/Peuget.png";
import volkswagon from "images/Volkswagon.png";

const brands = [
    { name: "Audi", logo: Audi },
    { name: "BMW", logo: BMW },
    { name: "Ford", logo: Ford },
    { name: "Peugeot", logo: Peugeot },
    { name: "Volkswagen", logo: volkswagon },
];

interface CardProps {
    title: string;
    description: string;
}

const BrowseLocation = () => {
    const [visibleStartIndex, setVisibleStartIndex] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(2);
    const cards = [
        {
            title: "Los Angeles",
            description:
                "There are many variations of lorem duos lora spassages of Lorem Ipsum available internet tend.",
        },
        {
            title: "New York",
            description:
                "Explore the big apple and discover hidden gems in the city that never sleeps.",
        },
        {
            title: "San Francisco",
            description:
                "Known for its iconic Golden Gate Bridge and vibrant tech scene.",
        },
        {
            title: "Chicago",
            description:
                "The Windy City offers architectural marvels and deep-dish pizza.",
        },
        {
            title: "Miami",
            description:
                "Sun, beaches, and vibrant nightlife await you in Miami.",
        },
    ];

    const Card: React.FC<CardProps> = ({ title, description }) => {
        return (
            <div className="p-6 bg-[#FFFFFF1A] text-black rounded-xl shadow-md flex flex-col items-start min-w-[300px]">
                <svg
                    width="44"
                    height="45"
                    viewBox="0 0 44 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect y="0.560059" width="44" height="44" rx="22" fill="#AD0419" />
                    <path
                        d="M32 20.5601V19.7775C32 17.8379 32 16.8681 31.4142 16.2656C30.8284 15.663 29.8856 15.663 28 15.663H25.9214C25.004 15.663 24.9964 15.6612 24.1715 15.2484L20.8399 13.5812C19.4488 12.8851 18.7533 12.537 18.0124 12.5612C17.2714 12.5854 16.5988 12.9781 15.2534 13.7636L14.0256 14.4804C13.0374 15.0573 12.5433 15.3458 12.2716 15.8257C12 16.3056 12 16.89 12 18.0588V26.2758C12 27.8115 12 28.5794 12.3423 29.0068C12.57 29.2911 12.8892 29.4823 13.242 29.5457C13.7723 29.6409 14.4215 29.2619 15.7199 28.5038C16.6016 27.9891 17.4501 27.4545 18.5049 27.5995C19.3887 27.7209 20.21 28.2786 21 28.6739"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M18 12.5601V27.5601" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
                    <path d="M25 15.5601V20.0601" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M28.3083 32.2436C28.0915 32.4466 27.8017 32.5601 27.5001 32.5601C27.1985 32.5601 26.9087 32.4466 26.6919 32.2436C24.7063 30.3731 22.0455 28.2836 23.3431 25.2499C24.0447 23.6097 25.7289 22.5601 27.5001 22.5601C29.2713 22.5601 30.9555 23.6097 31.6571 25.2499C32.9531 28.2797 30.2988 30.3795 28.3083 32.2436Z"
                        stroke="white"
                        strokeWidth="1.5"
                    />
                    <path d="M27.5 27.0601H27.509" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

                <h3 className="text-xl text-white font-semibold my-2">{title}</h3>
                <p className="text-[#FFFFFFB2]">{description}</p>
            </div>
        );
    };

    const handleResize = () => {
        if (window.innerWidth >= 1280) {
            setItemsPerPage(4); // xl
        } else if (window.innerWidth >= 1024) {
            setItemsPerPage(3); // lg
        } else if (window.innerWidth >= 768) {
            setItemsPerPage(2); // md
        } else {
            setItemsPerPage(1); // sm
        }
    };

    useEffect(() => {
        handleResize(); // Set initial items per page
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleNext = () => {
        if (visibleStartIndex + itemsPerPage < cards.length) {
            setVisibleStartIndex(visibleStartIndex + itemsPerPage);
        }
    };

    const handlePrevious = () => {
        if (visibleStartIndex - itemsPerPage >= 0) {
            setVisibleStartIndex(visibleStartIndex - itemsPerPage);
        }
    };

    return (
        <>
            <div className="flex items-center w-full">
                <div className="flex justify-center items-center w-full ">
                    <h2 className="text-4xl font-semibold text-white">Browse By Location</h2>
                </div>
            </div>
            <div className="flex flex-row justify-end space-x-2 !mt-2 pr-4">
                <button
                    className={`w-10 h-10 flex items-center justify-center rounded-full bg-[#FFFFFF1A] hover:bg-gray-400 ${visibleStartIndex === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                    aria-label="Previous"
                    onClick={handlePrevious}
                    disabled={visibleStartIndex === 0}
                >
                    <ChevronLeftIcon className="w-6 h-6 text-white" />
                </button>
                <button
                    className={`w-10 h-10 flex items-center justify-center rounded-full bg-[#FFFFFF1A] hover:bg-gray-400 ${visibleStartIndex + itemsPerPage >= cards.length ? 'opacity-50 cursor-not-allowed' : ''}`}
                    aria-label="Next"
                    onClick={handleNext}
                    disabled={visibleStartIndex + itemsPerPage >= cards.length}
                >
                    <ChevronRightIcon className="w-6 h-6 text-white" />
                </button>
            </div>
            <div className="flex justify-center !mt-12">
                <div className={`grid gap-12`} style={{ gridTemplateColumns: `repeat(${itemsPerPage}, minmax(0, 1fr))` }}>
                    {cards.slice(visibleStartIndex, visibleStartIndex + itemsPerPage).map((card, index) => (
                        <Card
                            key={index}
                            title={card.title}
                            description={card.description}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default BrowseLocation;
